import React, { useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from "react-router";
import { Navigate } from "react-router-dom";
import { register } from "../../Sevices/api-requests";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  image: {
    backgroundImage: "url(https://i.imgur.com/IbqcGaI.jpg)",
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "cover",
    backgroundPosition: "top center",
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));
function SignUp({ isLoggedIn }) {
  const classes = useStyles();

  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [matricNo, setMatricNo] = useState("");
  const [password, setPassword] = useState("");
  const [level, setLevel] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleBtnClick = () => {
    setDisabled(true);
  };

  const saveUserAndToken = (user) => {
    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("user_token", JSON.stringify(user.token));
      return;
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setDisabled(true);
    if (password !== confirmPassword) {
      alert("password do not match");
    }
    try {
      // const user = await register({
      //   firstName,
      //   lastName,
      //   matricNo,
      //   level,
      //   email,
      //   password,
      // });
      // console.log(user.data.data);
      // saveUserAndToken(user.data.data);
      // navigate("/dashboard");
      // window.location.reload();
      setError("Registration closed")
    } catch (error) {
      setError(error.message);
      setDisabled(false);
    }
  };
  // const classSet = ["100","200","300","400","500", "600"]
  const classSetObj = [
    { level: "100", name: "2k27" },
    { level: "200", name: "2k26" },
    { level: "300", name: "2k25" },
    { level: "400", name: "2k24" },
    { level: "500", name: "2k23" },
    { level: "600", name: "2k21" },
  ];
  return isLoggedIn ? (
    <Navigate replace to="/dashboard" />
  ) : (
    <Grid component="main" container className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Register
          </Typography>
          <form
            className={classes.form}
            onSubmit={handleSubmit}
            validate="true"
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  autoComplete="name"
                  name="firstName"
                  variant="outlined"
                  required
                  fullWidth
                  id="fullName"
                  label="First Name"
                  autoFocus
                  value={firstName}
                  onChange={(event) => {
                    const { value } = event.target;
                    setFirstName(value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  autoComplete="name"
                  name="lastName"
                  variant="outlined"
                  required
                  fullWidth
                  id="lastName"
                  label="Last Name"
                  autoFocus
                  value={lastName}
                  onChange={(event) => {
                    const { value } = event.target;
                    setLastName(value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="matricNo"
                  label="Matric Number"
                  name="matricno"
                  type="number"
                  autoComplete="mNumber"
                  value={matricNo}
                  onChange={(event) => {
                    const { value } = event.target;
                    setMatricNo(Number(value));
                  }}
                />
              </Grid>
              {/* <Grid item xs={12} sm={6}>
              <Button 
              variant='contained'
              component="label">
                 Upload Avatar
                 <input type='file'  
          onChange= {(event) => {
         if(event.target.files[0]){
           setImage(event.target.files[0])
         }
            
          }}
                 hidden />
              </Button>
            
            </Grid> */}
              <Grid item xs={12} sm={6}>
                <FormControl className={classes.formControl}>
                  <InputLabel id="demo-controlled-open-select-label">
                    Level
                  </InputLabel>
                  <Select
                    labelId="demo-controlled-open-select-label"
                    id="demo-controlled-open-select"
                    ariant="outlined"
                    required
                    fullWidth
                    label="Level"
                    name="level"
                    autoComplete="level"
                    value={level}
                    onChange={(event) => {
                      const { value } = event.target;
                      setLevel(value);
                    }}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {classSetObj.map((c, i) => {
                      return <MenuItem value={c.level}>{c.name}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  value={email}
                  onChange={(event) => {
                    const { value } = event.target;
                    setEmail(value);
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  onChange={(event) => {
                    const { value } = event.target;
                    setPassword(value);
                  }}
                  value={password}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="confirm-password"
                  label="Confirm Password"
                  type="password"
                  autoComplete="Confirm Password"
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={(event) => {
                    const { value } = event.target;
                    setConfirmPassword(value);
                  }}
                />
              </Grid>
              <Grid>
                {error ? (
                  <Box color="red" xs={12} sm={6}>
                    {error}!!!
                  </Box>
                ) : null}
              </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              disabled={disabled}
              // omClick={handleBtnClick}
            >
              Sign Up
            </Button>
            <Grid container justify="center">
              <Grid item>
                <Link href="/login" variant="body2">
                  Already have an account? Sign in
                </Link>
              </Grid>
            </Grid>
          </form>
        </div>
      </Grid>
    </Grid>
  );
}

export default SignUp;
